module.exports = __webpack_public_path__ + "static/media/call.de6c770b.svg";